<template>
  <div id="NotFound">
    <h1>Pagina non trovata</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>
<style scoped>
</style>
